export function isOnline() {
  return window.navigator.onLine
}
